import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';
import { useEffect } from 'react';

export default function ReparationFenetreTassinLaDemiLune() {
  useEffect(() => {
    document.title = 'Tassin-la-Demi-Lune Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Tassin-la-Demi-Lune Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Tassin-la-Demi-Lune. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Tassin-la-Demi-Lune, dépannage fenêtres Tassin-la-Demi-Lune, vitrier Tassin-la-Demi-Lune');
    }

    const linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) {
      linkCanonical.setAttribute('href', 'https://fenetres-lyon.com/reparation-fenetre-tassin-la-demi-lune');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CityHero 
        cityName="Tassin-la-Demi-Lune"
        imageSeq="tassin-la-demi-lune-hero-014"
      />
      <Services />
      <Testimonials />
      <Contact />
      <FAQ />
      <Footer />
    </div>
  );
}
